import store from '@/store/'
export const checkAppLimits = async ({ to, next }) => {
  if (to.params.id !== null && to.params.id !== undefined) {
    return checkClientAppLimits({ to, next })
  } else {
    if (!store.state.campaigns.limitsLoaded) store.dispatch('campaigns/loadAppLimits')

    return next()
  }
}

export const checkClientAppLimits = async ({ to, next }) => {
  if (to.params.id !== null && to.params.id !== undefined) {
    store.dispatch('campaigns/loadClientAppLimits', {
      campaign_id: to.params.id,
    })
  }
  return next()
}
